<template>
    <span>
        <slot/><template v-if="array && array.length !== 1">s</template>
    </span>
</template>

<script>
    //TODO make directive?
  export default {
    name: "Pluralize",
    props: {"array" : {type : Array}},
  }
</script>

<style scoped>

</style>
